export class PaymentDetails {
  id: string;
  quoteId?: string;
  contact: {
    id: string;
    name: string;
    phone: string;
    email: string;
  };
  shippingAddressId: number;
  area: string;
  carrierCode: number;
  finalDestination: number;
  billingAddressId?: number;
  billingAddressTypeId?: number;
  defaultAddressId?: any;
  doNotMail: boolean;
  customerReference: string;
  creditCard: boolean;
  purchaseOrderNumber?: string;
  purchaseOrder?: {
    id: string;
    purchaseOrderNumber: string;
  };
  paymentTermsId: number;
  quoteAttributes: {
    customerType: number;
    lineNumber: boolean;
    oemSku: boolean;
    commCode: boolean;
    countryOfOrigin: boolean;
    sinNumber: boolean;
    listPrice: boolean;
    netPrice: boolean;
    grandTotal: boolean;
    lineNotes: boolean;
    quoteNotes: boolean;
    vat: boolean;
    lineWeight: boolean;
    estimatedShipDate: boolean;
    hideInactiveCustomers: boolean;
  };
  lnCountryName?: string;
  blockOrder: boolean;
  shipToComplete: boolean;
}
